import { render, staticRenderFns } from "./Bahn1CountdownTimer.vue?vue&type=template&id=2203e274&scoped=true&"
import script from "./Bahn1CountdownTimer.vue?vue&type=script&lang=js&"
export * from "./Bahn1CountdownTimer.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1CountdownTimer.vue?vue&type=style&index=0&id=2203e274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203e274",
  null
  
)

export default component.exports